import {
  Divider,
  LoadingSpinner,
} from '@data-products-and-ai/react-components';
import SearchViewSelector from '../ui/SearchViewSelector';
import { useEffect, useState } from 'react';
import DataTable from '../ui/DataTable';
import { GridColType } from '@mui/x-data-grid';

const PartsSales = () => {
  const [selectedView, setSelectedView] = useState('table');
  const [loading, setLoading] = useState(true);
  const columns = [
    {
      field: 'id',
      headerName: 'Customer ID',
      type: 'string' as GridColType,
    },
    {
      field: 'name',
      headerName: 'Customer Name',
      type: 'string' as GridColType,
    },
    {
      field: 'country',
      headerName: 'Customer Country',
      type: 'string' as GridColType,
    },
    {
      field: 'machine',
      headerName: 'Machine/Unit ID',
      type: 'string' as GridColType,
    },
    {
      field: 'part',
      headerName: 'Part Number',
      type: 'number' as GridColType,
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      type: 'number' as GridColType,
    },
    {
      field: 'price',
      headerName: 'Net Price',
      type: 'number' as GridColType,
    },
    {
      field: 'currency',
      headerName: 'Currency',
      type: 'string' as GridColType,
    },
    {
      field: 'value',
      headerName: 'Net Value',
      type: 'number' as GridColType,
    },
  ];

  useEffect(() => {
    console.log(selectedView);
    setLoading(false);
  }, []);

  function handleSearch(value: string): void {
    console.log(value);
    throw new Error('Function not implemented.');
  }

  return (
    <div>
      <div className="partsSales__container">
        <div className="partsSales__searchSection"></div>
        <SearchViewSelector
          dataSelectedView={setSelectedView}
          handleSearch={handleSearch}
        />
        <Divider data-testid="divider" />
        {loading ? (
          <div className="partsSales__loading">
            <LoadingSpinner
              color="#8a00e5"
              backgroundColor="#ADA9C2"
              text="Search results are loading"
            />{' '}
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={[]}
            noResultsMessage="No results for your search terms."
          />
        )}
      </div>
    </div>
  );
};
export default PartsSales;
